var caution = "https://shopfront-cdn.tekoapis.com/static/a1690276bae7d213.svg";

export { caution as default };
